import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseModalDialogDirective } from 'src/app/shared/directives/base-modal-dialog.directive';
import { ModalSize } from 'src/app/shared/enums/modal-size.enum';
import { BaseModel } from 'src/app/shared/types/generated.types';

@Component({
  selector: 'app-custom-select-modal',
  templateUrl: './custom-select-modal.component.html',
  styleUrls: ['./custom-select-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CustomSelectModalComponent<T extends BaseModel> extends BaseModalDialogDirective {
  itemFilter: string[];
  selectTitle = 'Select';
  selectIcon: string | null = null;
  items: T[] = [];
  selectedItemId: string | null = null;

  get size(): ModalSize {
    return ModalSize.Large;
  }

  constructor() {
    super();
  }

  applyFilter(filterValue: string): void {
    this.itemFilter = [filterValue.trim().toLowerCase()]; // Remove whitespace & to lowercase
  }

  selectItem(item: T): void {
    this.selectedItemId = item.id;
    this.close(item);
  }

  isItemSelected(itemId: string | null): boolean {
    if (!this.items) {
      return false;
    }
    return this.selectedItemId == itemId;
  }
}
